import React from 'react'
import Error404 from './error404'
import Error403 from './error403'

function errorPage(props) {
    const {status}=props
  return (
    status===404?(<>
        <Error404/>
    </>):(
        <>
        <Error403/></>
    )
   
  )
}

export default errorPage